export default "__VITE_ASSET__DMuah1JB__"